import React, { useEffect, useState } from "react";
import { Checkbox } from "@mui/material";
import { ChannelContainer, Container, Divider, Title, InputContainer } from "./styles";
import { useUser } from "../../contexts/UserContext";
import FollowerMetaConfig from "../FollowerMetaConfig";
import Translator from "../../components/i18nComponents/Translator";
import { useTranslation } from "react-i18next";

export default function ConfigureMetaFollower() {

  const { metaFollersData, getMetaFollowersData } = useUser();
  const { t } = useTranslation();
  const [enableAdvance, setEnable] = useState(false);

  useEffect(() => {
    getMetaFollowersData();
  }, []);

  return (
    <Container>
      <Title><Translator path="paginas.copyTrader.Title"/></Title>
      <Divider />

      <InputContainer style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Checkbox
          checked={enableAdvance}
          name="enableAdvance"
          id="idEn"
          onChange={() => setEnable(!enableAdvance)}
        />
        <div>{t("componentes.ChannelCardComponente.advanceBox")}</div>
      </InputContainer>

      <ChannelContainer>
        {metaFollersData.map((trader, index) => (
          <FollowerMetaConfig trader={trader}
          key={index}
          enableAdvance={enableAdvance} />
        ))}
      </ChannelContainer>
    </Container>
  );
}
